import { render, staticRenderFns } from "./DriverWasteDisposals.vue?vue&type=template&id=6dffa7d6&scoped=true&"
import script from "./DriverWasteDisposals.vue?vue&type=script&lang=js&"
export * from "./DriverWasteDisposals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dffa7d6",
  null
  
)

export default component.exports